export enum PlanInterval {
  Monthly = 0,
  Annually = 1,
}
